import { render, staticRenderFns } from "./InfrastructureGroup.vue?vue&type=template&id=078a326c"
import script from "./InfrastructureGroup.vue?vue&type=script&lang=ts"
export * from "./InfrastructureGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports